export function get<T>(array: T[]|undefined, index: number): T|undefined {
    return (array === undefined ? undefined : (
        array[index]
    ))
}